
<div class="modal-dialog confirm-dialog">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">Reject Order</h5>
      <button class="close" type="button" (click)="cancel()">&times;</button>
    </div>
    <div class="modal-body">
      <error [error]="error"></error>
      <div class="row">
        <div class="form-group col">
          <label class="required" for="rejectReasons">Reasons to Reject Order</label>
          <textarea class="form-control" id="rejectReasons" [(ngModel)]="rejectReasons" name="rejectReasons" rows="6" maxlength="300"></textarea>
          <!--input#rejectReasons.form-control(type='text', [(ngModel)]="rejectReasons", name="key", maxlength="50", minlength="1", required)
          -->
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-primary" type="button" (click)="rejectOrder()">Reject</button>
      <button class="btn btn-outline-secondary" type="button" (click)="cancel()">Cancel</button>
    </div>
  </div>
</div>